// FirstLoginFlow.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Box } from '@mui/material';
import EULAModal from './EULAModal';

const FirstLoginFlow = () => {
    const [step, setStep] = useState(1);
    const navigate = useNavigate();
    const signedEula = useSelector((state) => state.auth.signedEula);
    const handleAgree = () => {
        navigate('/dashboard');
    };

    // const handleChangePassword = async () => {
    //     console.log('Password changed successfully');
    //     dispatch(logout());
    //     navigate('/login');
    // };

    return (
        <Box>
            {!signedEula && (
                <EULAModal 
                    open={step === 1} // EULA
                    onClose={() => setStep(2)} // Password reset
                    onAgree={handleAgree}
                />
            )}
            {/* {signedEula && isFirstLogin && (
                <ChangePasswordComponent onSubmit={handleChangePassword} />
            )} */}
        </Box>
    );
};

export default FirstLoginFlow;
